import React, { useState, useEffect, useCallback } from "react";

/* ════════════════════════════════════════════════════════════════
   ⬇️ MODIFIABLE — Données de personnalisation
   ════════════════════════════════════════════════════════════════ */
const CONFIG = {
  name:         "Anthony Rodriguez",
  role:         "Développeur web freelance — SlimeTech",
  tagline:      "SlimeTech accompagne les indépendants, TPE et PME dans la création de sites internet, d'applications web et de solutions logicielles personnalisées. De l'idée au produit digital qui inspire confiance et génère des résultats.",
  availability: "Disponible pour de nouveaux projets",
  email:        "slime-tech@outlook.fr",
  location:     "France — Remote disponible",
  schedule:     "Lun — Ven, 9h — 18h",
  stats: [
    { val: "+10",   lbl: "Projets réalisés" },
    { val: "4 ans", lbl: "D'expérience"    }
  ],
  tags: ["HTML / CSS", "JavaScript", "React", "Angular", "Node.js", "Spring Boot"]
};

/* ════════════════════════════════════════════════════════════════
   — Services proposés
   ════════════════════════════════════════════════════════════════ */
const SERVICES = [
  {
    icon:  "bi-window-split",
    color: "si-purple",
    title: "Création de sites internet",
    desc:  "Votre présence en ligne commence ici. Je crée des sites vitrines élégants, rapides et optimisés SEO pour les indépendants, TPE et PME.",
    detail: {
      intro: "Votre site vitrine est votre première impression en ligne — il doit inspirer confiance, se charger vite et être visible sur Google.",
      bullets: [
        { icon: "bi-palette",          title: "Design sur-mesure",       text: "Interface moderne adaptée à votre identité visuelle et à votre secteur d'activité." },
        { icon: "bi-phone",            title: "Mobile-first",             text: "Expérience optimale sur smartphone, tablette et ordinateur sans aucun compromis." },
        { icon: "bi-search",           title: "SEO natif",                text: "Structure HTML sémantique, balises meta, données structurées et Core Web Vitals optimisés dès la conception." },
        { icon: "bi-lightning-charge", title: "Performance",              text: "Images compressées, code minifié, cache navigateur — un site rapide que Google et vos visiteurs apprécient." },
        { icon: "bi-envelope-check",   title: "Formulaire de contact",    text: "Intégré et opérationnel dès la livraison, avec confirmation par email." },
        { icon: "bi-rocket-takeoff",   title: "Accompagnement complet",   text: "Mise en ligne, configuration de l'hébergement et formation à la prise en main incluses." },
      ],
      stack: "HTML5, CSS3, JavaScript, React",
      delay: "Délai moyen : 2 à 4 semaines",
    },
  },
  {
    icon:  "bi-layers",
    color: "si-cyan",
    title: "Applications web sur mesure",
    desc:  "Besoin d'une solution logicielle personnalisée ? Je développe des applications web robustes et évolutives avec React, Angular, Node.js, Java ou Spring Boot.",
    detail: {
      intro: "Les logiciels génériques ne couvrent pas toujours vos processus métier. Je conçois l'outil qui correspond exactement à vos besoins.",
      bullets: [
        { icon: "bi-clipboard-check",  title: "Analyse des besoins",      text: "Cadrage complet de votre projet avant d'écrire la première ligne de code." },
        { icon: "bi-diagram-3",        title: "Architecture solide",       text: "API REST, base de données relationnelle ou NoSQL, logique métier robuste et évolutive." },
        { icon: "bi-people",           title: "Interface intuitive",       text: "UX pensée pour vos utilisateurs finaux, pas pour les développeurs." },
        { icon: "bi-shield-check",     title: "Authentification & sécurité", text: "Gestion des rôles, sessions sécurisées, protection des données conformément au RGPD." },
        { icon: "bi-check2-circle",    title: "Tests rigoureux",           text: "Validation fonctionnelle et technique avant chaque mise en production." },
        { icon: "bi-file-text",        title: "Documentation",             text: "Code commenté et guide d'utilisation livrés avec l'application." },
      ],
      stack: "React, Angular, Node.js, Java, Spring Boot, SQL, API REST",
      delay: "Délai moyen : 4 à 12 semaines selon la complexité",
    },
  },
  {
    icon:  "bi-arrow-repeat",
    color: "si-violet",
    title: "Refonte & migration web",
    desc:  "Votre site est dépassé ou peu performant ? Je diagnostique, modernise et relance votre présence digitale avec une API REST ou une architecture moderne.",
    detail: {
      intro: "Votre site actuel ne reflète plus votre image ou ses performances plombent votre référencement ? Je vous aide à repartir sur de meilleures bases.",
      bullets: [
        { icon: "bi-clipboard-data",   title: "Audit préalable",          text: "Analyse complète des performances, du SEO, de l'UX et du code existant avant tout travail." },
        { icon: "bi-cpu",              title: "Nouvelle architecture",     text: "Migration vers une stack moderne, maintenable et performante." },
        { icon: "bi-search-heart",     title: "SEO préservé",             text: "Redirections 301, conservation des URLs stratégiques et transmission du jus de lien." },
        { icon: "bi-palette2",         title: "Refonte graphique",        text: "Nouveau design moderne et cohérent avec votre identité visuelle actuelle." },
        { icon: "bi-database-check",   title: "Migration des données",    text: "Transfert sécurisé de vos contenus et de vos données existantes." },
        { icon: "bi-activity",         title: "Continuité de service",    text: "Transition planifiée pour minimiser l'impact sur votre activité en ligne." },
      ],
      stack: "React, Angular, Node.js, API REST, bases de données",
      delay: "Délai moyen : 3 à 8 semaines",
    },
  },
  {
    icon:  "bi-tools",
    color: "si-green",
    title: "Maintenance & évolution",
    desc:  "Votre site mérite d'être entretenu dans le temps. Je propose des contrats de maintenance, mises à jour et évolutions fonctionnelles sur SQL ou NoSQL.",
    detail: {
      intro: "Un site ou une application nécessite un suivi régulier pour rester performant, sécurisé et à jour. Je vous accompagne sur la durée.",
      bullets: [
        { icon: "bi-arrow-up-circle",  title: "Mises à jour",             text: "Dépendances, sécurité, compatibilité navigateurs — tout maintenu à jour en continu." },
        { icon: "bi-bug",              title: "Correction de bugs",        text: "Intervention rapide dès qu'un problème est signalé ou détecté." },
        { icon: "bi-plus-circle",      title: "Évolutions fonctionnelles", text: "Ajout de nouvelles fonctionnalités au rythme de vos besoins." },
        { icon: "bi-cloud-arrow-up",   title: "Sauvegardes",              text: "Protection régulière de vos données et de votre code source." },
        { icon: "bi-bar-chart-line",   title: "Monitoring",               text: "Surveillance des performances et de la disponibilité de votre service." },
        { icon: "bi-file-earmark-bar-graph", title: "Rapports mensuels",  text: "Bilan des actions réalisées et recommandations pour la période suivante." },
      ],
      stack: "Selon votre projet existant",
      delay: "Intervention sous 24h ouvrées",
    },
  },
  {
    icon:  "bi-lightbulb",
    color: "si-orange",
    title: "Audit & conseil web",
    desc:  "Pas sûr de la direction à prendre ? Je vous accompagne dans vos choix technologiques et la définition de votre stratégie digitale.",
    detail: {
      intro: "Vous avez un projet ou une problématique et ne savez pas par où commencer ? Un regard expert peut vous faire économiser du temps et de l'argent.",
      bullets: [
        { icon: "bi-code-slash",       title: "Audit technique",          text: "Analyse du code, des performances, de la sécurité et de l'architecture existante." },
        { icon: "bi-search",           title: "Audit SEO",                text: "Positionnement, structure, balises, Core Web Vitals et opportunités d'amélioration identifiées." },
        { icon: "bi-hand-index",       title: "Audit UX",                 text: "Parcours utilisateur, accessibilité, points de friction et recommandations concrètes." },
        { icon: "bi-cpu",              title: "Conseil technologique",    text: "Choix du framework, de l'hébergeur, de la stack — sans jargon inutile." },
        { icon: "bi-map",              title: "Feuille de route",         text: "Plan d'action priorisé avec estimations de temps et de coûts réalistes." },
        { icon: "bi-file-earmark-pdf", title: "Rapport détaillé",         text: "Document complet livré en PDF avec recommandations actionnables et classées par priorité." },
      ],
      stack: "Lighthouse, Google Search Console, PageSpeed Insights",
      delay: "Rapport livré en 3 à 5 jours ouvrés",
    },
  },
  {
    icon:  "bi-graph-up-arrow",
    color: "si-pink",
    title: "SEO & performance",
    desc:  "Un beau site invisible ne sert à rien. J'optimise la vitesse, l'accessibilité et le référencement naturel pour maximiser votre visibilité.",
    detail: {
      intro: "Un site invisible sur Google ne génère pas de clients. J'optimise votre référencement et vos performances pour que vous soyez trouvé.",
      bullets: [
        { icon: "bi-tags",             title: "Optimisation on-page",     text: "Balises title, meta description, H1/H2, maillage interne et données structurées JSON-LD." },
        { icon: "bi-speedometer2",     title: "Core Web Vitals",          text: "LCP, CLS et INP optimisés pour satisfaire les critères de ranking de Google." },
        { icon: "bi-lightning",        title: "Vitesse de chargement",    text: "Compression, lazy loading, mise en cache, minification CSS/JS." },
        { icon: "bi-robot",            title: "Indexation",               text: "Sitemap XML, robots.txt, canonical tags — configuration correcte pour les crawlers." },
        { icon: "bi-share",            title: "Open Graph",               text: "Optimisation du partage sur les réseaux sociaux (LinkedIn, Facebook, X/Twitter)." },
        { icon: "bi-graph-up",         title: "Suivi & reporting",        text: "Rapport avant/après avec métriques clés et recommandations continues." },
      ],
      stack: "Google Search Console, Lighthouse, PageSpeed Insights",
      delay: "Résultats visibles en 4 à 12 semaines",
    },
  },
];

/* ════════════════════════════════════════════════════════════════
   — Stack technique
   ════════════════════════════════════════════════════════════════ */
const TECH_STACK = [
  { name: "HTML / CSS",        icon: "bi-filetype-html" },
  { name: "JavaScript",        icon: "bi-filetype-js" },
  { name: "React",             icon: "bi-braces" },
  { name: "Angular",           icon: "bi-code-square" },
  { name: "Node.js",           icon: "bi-server" },
  { name: "Java",              icon: "bi-cup-hot-fill" },
  { name: "Spring Boot",       icon: "bi-leaf" },
  { name: "API REST",          icon: "bi-diagram-3" },
  { name: "SQL",               icon: "bi-database" },
  { name: "SEO & Performance", icon: "bi-graph-up-arrow" },
  { name: "Responsive Design", icon: "bi-phone" },
  { name: "Git",               icon: "bi-git" },
];

/* ════════════════════════════════════════════════════════════════
   — Pourquoi SlimeTech
   ════════════════════════════════════════════════════════════════ */
const WHY_ITEMS = [
  {
    icon:  "bi-person-check",
    title: "Un interlocuteur unique",
    desc:  "Pas d'intermédiaire, pas d'agence. Vous travaillez directement avec le développeur qui conçoit et livre votre projet — du devis à la mise en ligne.",
  },
  {
    icon:  "bi-lightning-charge",
    title: "Réactivité & transparence",
    desc:  "Réponse sous 24h, suivi régulier et livrables dans les délais. Je m'adapte à votre rythme de travail et à vos contraintes.",
  },
  {
    icon:  "bi-puzzle",
    title: "Solutions sur mesure",
    desc:  "Chaque projet est unique. Qu'il s'agisse d'un site internet, d'une application web ou d'une solution logicielle personnalisée, je construis ce dont vous avez besoin.",
  },
];

/* ════════════════════════════════════════════════════════════════
   HOOK — Navigation post-splash (si l'utilisateur a cliqué un item final)
   ════════════════════════════════════════════════════════════════ */
const useSplashNav = () => {
  useEffect(() => {
    const handler = (e) => {
      const targetId = e.detail;
      setTimeout(() => {
        const el = document.getElementById(targetId);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 950);
    };
    window.addEventListener("sp-navigate", handler);
    return () => window.removeEventListener("sp-navigate", handler);
  }, []);
};

/* ════════════════════════════════════════════════════════════════
   HOOK — Scroll vers l'ancre de l'URL au chargement de la page
   (fix navigation depuis une page interne : /#services → scroll vers #services)
   ════════════════════════════════════════════════════════════════ */
const useHashScroll = () => {
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (!hash) return;
    const t = setTimeout(() => {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 120);
    return () => clearTimeout(t);
  }, []);
};

/* ════════════════════════════════════════════════════════════════
   HOOK — Animation au scroll (IntersectionObserver)
   ════════════════════════════════════════════════════════════════ */
const useScrollAnim = () => {
  useEffect(() => {
    const els = document.querySelectorAll(".anim-up");
    if (!els.length) return;

    const obs = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            obs.unobserve(e.target);
          }
        }),
      { threshold: 0.1, rootMargin: "0px 0px -36px 0px" }
    );

    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);
};

/* ════════════════════════════════════════════════════════════════
   COMPOSANT PRINCIPAL — Page Accueil (one-pager)
   ════════════════════════════════════════════════════════════════ */
const Accueil = () => {
  useScrollAnim();
  useSplashNav();
  useHashScroll();

  /* ── Modal service ── */
  const [activeService, setActiveService] = useState(null);
  const closeModal = useCallback(() => setActiveService(null), []);

  useEffect(() => {
    if (!activeService) return;
    const onKey = (e) => { if (e.key === "Escape") closeModal(); };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [activeService, closeModal]);

  /* ── État formulaire de contact ── */
  const [form,   setForm]   = useState({ name: "", email: "", subject: "", message: "" });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle"); // idle | loading | success | error

  /* ── Bouton scroll-to-top ── */
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const cb = () => setShowTop(window.scrollY > 400);
    window.addEventListener("scroll", cb, { passive: true });
    return () => window.removeEventListener("scroll", cb);
  }, []);

  /* ────────────────────────────────────────────────────────────
     FORMULAIRE — Validation et envoi
     ──────────────────────────────────────────────────────────── */
  const validate = useCallback((data) => {
    const e = {};
    if (!data.name.trim() || data.name.trim().length < 2)
      e.name = "Veuillez entrer votre nom (min. 2 caractères).";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email))
      e.email = "Adresse email invalide.";
    if (!data.subject.trim())
      e.subject = "Le sujet est requis.";
    if (data.message.trim().length < 10)
      e.message = "Le message doit faire au moins 10 caractères.";
    return e;
  }, []);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    setErrors((er) => ({ ...er, [name]: "" }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate(form);
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setStatus("loading");

    try {
      /* ══════════════════════════════════════════════════════════
         ENVOI RÉEL — EmailJS (service gratuit, sans backend)
         ══════════════════════════════════════════════════════════*/
      const EMAILJS_SERVICE_ID  = "service_xtl83d6";
      const EMAILJS_TEMPLATE_ID = "template_4di9i5a";

      await window.emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, {
        from_name:  form.name,
        from_email: form.email,
        subject:    form.subject,
        message:    form.message,
        to_email:   CONFIG.email,
      });

      setStatus("success");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      console.error("Erreur envoi formulaire :", err);
      setStatus("error");
    }
  };

  /* ════════════════════════════════════════════════════════════════
     RENDU
     ════════════════════════════════════════════════════════════════ */
  return (
    <main>

      {/* ══════════════════════════════════════════════════════════
          SECTION 1 — PRÉSENTATION / HERO
          ══════════════════════════════════════════════════════════ */}
      <section id="hero" className="p-section s-hero">

        {/* Décorations fond */}
        <div className="hero-bg-deco" aria-hidden="true">
          <div className="deco-blob deco-blob-1" />
          <div className="deco-blob deco-blob-2" />
          <div className="deco-dots" />
        </div>

        <div className="p-container">
          <div className="hero-grid">

            {/* ── Colonne texte ── */}
            <div className="anim-up">

              {/* Badge disponibilité */}
              <div className="hero-avail">
                <span className="avail-dot" />
                {CONFIG.availability}
              </div>

              {/* Titre principal */}
              <h1 className="hero-title">
                Bonjour, je suis{" "}
                <span className="text-grad">{CONFIG.name}</span>
                <br />
                <span className="text-underline-accent">
                  {CONFIG.role}
                </span>
              </h1>

              <p className="hero-desc">{CONFIG.tagline}</p>

              {/* Tags technos */}
              <div className="hero-tags">
                {CONFIG.tags.map((t) => (
                  <span key={t} className="hero-tag">
                    <i className="bi bi-check2" />
                    {t}
                  </span>
                ))}
              </div>

              {/* Boutons CTA */}
              <div className="hero-cta">
                <a href="#services" className="btn-p btn-p--primary">
                  Voir mes services <i className="bi bi-arrow-right" />
                </a>
                <a href="#contact" className="btn-p btn-p--outline">
                  Discutons ensemble
                </a>
              </div>

              {/* Statistiques */}
              <div className="hero-stats">
                {CONFIG.stats.map((s, i) => (
                  <React.Fragment key={s.lbl}>
                    {i > 0 && <span className="stat-sep" />}
                    <div style={{ textAlign: "center" }}>
                      {/* ⬇️ MODIFIABLE */}
                      <span className="stat-num">{s.val}</span>
                      <span className="stat-lbl">{s.lbl}</span>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* ── Colonne visuelle — Avatar ── */}
            <div className="hero-visual anim-up d2">
              <div className="avatar-frame">
                <div className="avatar-glow" aria-hidden="true" />

                <div className="avatar-shape">
                  <img
                    src="/images/logo-slime-tech.png"
                    alt="Logo SlimeTech — Développeur web freelance"
                    className="avatar-img"
                    width="320"
                    height="320"
                    loading="eager"
                  />
                </div>

                <div className="avatar-ring" aria-hidden="true" />
              </div>

              {/* Floating pills déco */}
              <div className="float-pill float-pill--top" aria-hidden="true">
                <i className="bi bi-check-circle-fill" style={{ color: "#00c878" }} />
                Livraison dans les délais
              </div>
              <div className="float-pill float-pill--bot" aria-hidden="true">
                <i className="bi bi-star-fill" style={{ color: "#ffd700" }} />
                5.0 / 5 — Excellent
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          SECTION 2 — SERVICES
          ══════════════════════════════════════════════════════════ */}
      <section id="services" className="p-section s-services">
        <div className="p-container">

          {/* En-tête section */}
          <div className="sh-center anim-up">
            <span className="sh-eyebrow">Ce que je propose</span>
            <h2 className="sh-title">Mes Services</h2>
            <p className="sh-subtitle">
              Des solutions digitales adaptées à vos besoins, conçues avec soin et livrées dans les délais.
            </p>
          </div>

          {/* Grille de cards */}
          <div className="services-grid">
            {(() => {
              const srvIds = ["srv-web", "srv-app", "srv-api", "srv-auto", "srv-conseil", "srv-seo"];
              return SERVICES.map((s, i) => (
                <article
                  key={s.title}
                  id={srvIds[i]}
                  className={`srv-card anim-up d${(i % 3) + 1}`}
                >
                  {/* Icône */}
                  <div className={`srv-icon ${s.color}`}>
                    <i className={`bi ${s.icon}`} aria-hidden="true" />
                  </div>

                  <h3 className="srv-title">{s.title}</h3>
                  <p className="srv-desc">{s.desc}</p>

                  <button className="btn-p btn-p--outline srv-more-btn" onClick={() => setActiveService(s)}>
                    En savoir plus <i className="bi bi-arrow-right" />
                  </button>
                </article>
              ));
            })()}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          SECTION 3 — TECHNOLOGIES
          ══════════════════════════════════════════════════════════ */}
      <section id="technologies" className="p-section s-tech">
        <div className="p-container">

          <div className="sh-center anim-up">
            <span className="sh-eyebrow">Ma stack technique</span>
            <h2 className="sh-title">Technologies utilisées</h2>
            <p className="sh-subtitle">
              Des technologies modernes et éprouvées pour construire des solutions web robustes,
              maintenables et performantes — de la base de données SQL à l'API REST.
            </p>
          </div>

          <div className="tech-grid anim-up d2">
            {TECH_STACK.map((t) => (
              <div key={t.name} className="tech-pill">
                <i className={`bi ${t.icon}`} aria-hidden="true" />
                <span>{t.name}</span>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          SECTION 4 — POURQUOI SLIMETECH
          ══════════════════════════════════════════════════════════ */}
      <section id="why-slimetech" className="p-section s-why">
        <div className="p-container">

          <div className="sh-center anim-up">
            <span className="sh-eyebrow">Mon engagement</span>
            <h2 className="sh-title">Pourquoi travailler avec SlimeTech ?</h2>
            <p className="sh-subtitle">
              Des solutions logicielles sur mesure pour indépendants, TPE et PME —
              avec une approche simple, directe et orientée résultats.
            </p>
          </div>

          <div className="why-grid">
            {WHY_ITEMS.map((item, i) => (
              <div key={item.title} className={`why-card anim-up d${i + 1}`}>
                <div className="why-icon">
                  <i className={`bi ${item.icon}`} aria-hidden="true" />
                </div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          SECTION 5 — CONTACT
          ══════════════════════════════════════════════════════════ */}
      <section id="contact" className="p-section s-contact">
        <div className="p-container">

          {/* En-tête section */}
          <div className="sh-center anim-up">
            <span className="sh-eyebrow">Parlons de votre projet</span>
            <h2 className="sh-title">Me Contacter</h2>
            <p className="sh-subtitle">
              Une idée ? Un projet ? Une question ? Écrivez-moi, je réponds sous 24h.
            </p>
          </div>

          <div className="contact-grid">

            {/* ── Infos de contact ── */}
            <div className="ci-card anim-up">
              <h3 className="ci-card-title">Travaillons ensemble</h3>
              <p className="ci-card-intro">
                Que vous soyez une entreprise en quête de visibilité ou un porteur de projet avec une grande idée, je suis là pour vous aider à concrétiser vos ambitions digitales.
              </p>

              <ul className="ci-list">
                <li className="ci-item">
                  <div className="ci-icon-wrap">
                    <i className="bi bi-envelope" aria-hidden="true" />
                  </div>
                  <div>
                    <span className="ci-key">Email</span>

                    <span className="ci-val">{CONFIG.email}</span>
                  </div>
                </li>

                <li className="ci-item">
                  <div className="ci-icon-wrap">
                    <i className="bi bi-clock" aria-hidden="true" />
                  </div>
                  <div>
                    <span className="ci-key">Disponibilité</span>

                    <span className="ci-val">{CONFIG.schedule}</span>
                  </div>
                </li>

                <li className="ci-item">
                  <div className="ci-icon-wrap">
                    <i className="bi bi-geo-alt" aria-hidden="true" />
                  </div>
                  <div>
                    <span className="ci-key">Localisation</span>

                    <span className="ci-val">{CONFIG.location}</span>
                  </div>
                </li>
              </ul>
            </div>

            {/* ── Formulaire ── */}
            <div className="cf-card anim-up d2">
              <form
                className="cf-form"
                onSubmit={handleSubmit}
                noValidate
                aria-label="Formulaire de contact"
              >
                {/* Nom + Email */}
                <div className="cf-row">
                  <div className="cf-group">
                    <label className="cf-label" htmlFor="cf-name">
                      Nom complet <span className="cf-required">*</span>
                    </label>
                    <div className="cf-wrap">
                      <i className="bi bi-person cf-ico" aria-hidden="true" />
                      <input
                        id="cf-name"
                        name="name"
                        type="text"
                        className={`cf-input${errors.name ? " err" : ""}`}
                        placeholder="Jean Dupont"
                        value={form.name}
                        onChange={handleChange}
                        autoComplete="name"
                      />
                    </div>
                    {errors.name && (
                      <span className="cf-err-msg" role="alert">{errors.name}</span>
                    )}
                  </div>

                  <div className="cf-group">
                    <label className="cf-label" htmlFor="cf-email">
                      Adresse email <span className="cf-required">*</span>
                    </label>
                    <div className="cf-wrap">
                      <i className="bi bi-envelope cf-ico" aria-hidden="true" />
                      <input
                        id="cf-email"
                        name="email"
                        type="email"
                        className={`cf-input${errors.email ? " err" : ""}`}
                        placeholder="jean@exemple.fr"
                        value={form.email}
                        onChange={handleChange}
                        autoComplete="email"
                      />
                    </div>
                    {errors.email && (
                      <span className="cf-err-msg" role="alert">{errors.email}</span>
                    )}
                  </div>
                </div>

                {/* Sujet */}
                <div className="cf-group">
                  <label className="cf-label" htmlFor="cf-subject">
                    Sujet <span className="cf-required">*</span>
                  </label>
                  <div className="cf-wrap">
                    <i className="bi bi-tag cf-ico" aria-hidden="true" />
                    <input
                      id="cf-subject"
                      name="subject"
                      type="text"
                      className={`cf-input${errors.subject ? " err" : ""}`}
                      placeholder="Ex : Création d'un site vitrine"
                      value={form.subject}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.subject && (
                    <span className="cf-err-msg" role="alert">{errors.subject}</span>
                  )}
                </div>

                {/* Message */}
                <div className="cf-group">
                  <label className="cf-label" htmlFor="cf-message">
                    Message <span className="cf-required">*</span>
                  </label>
                  <div className="cf-wrap">
                    <i className="bi bi-chat-text cf-ico cf-ico-ta" aria-hidden="true" />
                    <textarea
                      id="cf-message"
                      name="message"
                      className={`cf-textarea${errors.message ? " err" : ""}`}
                      placeholder="Décrivez votre projet ou votre question..."
                      rows={5}
                      value={form.message}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.message && (
                    <span className="cf-err-msg" role="alert">{errors.message}</span>
                  )}
                </div>

                {/* Bouton envoi */}
                <button
                  type="submit"
                  className={`btn-p btn-p--primary btn-submit${status === "loading" ? " loading" : ""}`}
                  disabled={status === "loading"}
                >
                  <span className="btn-text">Envoyer le message</span>
                  <span className="btn-spinner" aria-hidden="true" />
                  <i className="bi bi-send" aria-hidden="true" />
                </button>

                {/* Messages de retour */}
                {status === "success" && (
                  <div className="cf-feedback cf-feedback--ok show" role="alert">
                    <i className="bi bi-check-circle-fill" aria-hidden="true" />
                    <span>Message envoyé avec succès ! Je vous répondrai dans les plus brefs délais.</span>
                  </div>
                )}
                {status === "error" && (
                  <div className="cf-feedback cf-feedback--err show" role="alert">
                    <i className="bi bi-exclamation-circle-fill" aria-hidden="true" />

                    <span>
                      Une erreur s'est produite. Réessayez ou écrivez directement à{" "}
                      <strong>{CONFIG.email}</strong>
                    </span>
                  </div>
                )}
              </form>
            </div>

          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          MODAL — Détail service
          ══════════════════════════════════════════════════════════ */}
      {activeService && (
        <div
          className="srv-modal-overlay"
          onClick={closeModal}
          role="dialog"
          aria-modal="true"
          aria-label={activeService.title}
        >
          <div className="srv-modal" onClick={(e) => e.stopPropagation()}>

            {/* Fermer */}
            <button className="srv-modal-close" onClick={closeModal} aria-label="Fermer">
              <i className="bi bi-x-lg" aria-hidden="true" />
            </button>

            {/* Icône + titre */}
            <div className={`srv-modal-icon-wrap ${activeService.color}`}>
              <i className={`bi ${activeService.icon}`} aria-hidden="true" />
            </div>
            <h2 className="srv-modal-title">{activeService.title}</h2>

            {/* Intro */}
            <p className="srv-modal-intro">{activeService.detail.intro}</p>

            {/* Liste des points */}
            <ul className="srv-modal-list">
              {activeService.detail.bullets.map((b) => (
                <li key={b.title} className="srv-modal-item">
                  <div className="srv-modal-item-icon">
                    <i className={`bi ${b.icon}`} aria-hidden="true" />
                  </div>
                  <div>
                    <strong className="srv-modal-item-title">{b.title} — </strong>
                    <span className="srv-modal-item-text">{b.text}</span>
                  </div>
                </li>
              ))}
            </ul>

            {/* Pied de modal */}
            <div className="srv-modal-footer">
              <div className="srv-modal-meta">
                <span><i className="bi bi-cpu" aria-hidden="true" /> {activeService.detail.stack}</span>
                <span><i className="bi bi-clock" aria-hidden="true" /> {activeService.detail.delay}</span>
              </div>
              <button
                className="btn-p btn-p--primary"
                onClick={() => {
                  closeModal();
                  setTimeout(() => {
                    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
                  }, 120);
                }}
              >
                Discutons de votre projet <i className="bi bi-arrow-right" aria-hidden="true" />
              </button>
            </div>

          </div>
        </div>
      )}

      {/* ── Bouton retour en haut ── */}
      <button
        className={`scroll-top-btn${showTop ? " visible" : ""}`}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Retour en haut de la page"
      >
        <i className="bi bi-chevron-up" aria-hidden="true" />
      </button>

    </main>
  );
};

export default Accueil;
